(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.vc-tabs').forEach(function(tabsEl) {
        var sectionId = tabsEl.id.replace('vc-tabs-', '');
        tabsEl.querySelectorAll('.vc-tab-btn').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var idx = btn.getAttribute('data-tab-index');
            tabsEl.querySelectorAll('.vc-tab-btn').forEach(function(b) {
              b.classList.remove('vc-tab-btn--active');
            });
            btn.classList.add('vc-tab-btn--active');
            document.querySelectorAll('.vc-tab-panel[data-section-id="' + sectionId + '"]').forEach(function(panel) {
              if (panel.getAttribute('data-tab-panel') === idx) {
                panel.classList.remove('vc-tab-panel--hidden');
              } else {
                panel.classList.add('vc-tab-panel--hidden');
              }
            });
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
